module.exports = __webpack_public_path__ + "static/banner.culture-d263b298cc2abc96b4514bbe86552e7f.png";